import { render, staticRenderFns } from "./KeywordViewer.vue?vue&type=template&id=7bfbf153&scoped=true&"
import script from "./KeywordViewer.vue?vue&type=script&lang=js&"
export * from "./KeywordViewer.vue?vue&type=script&lang=js&"
import style0 from "./KeywordViewer.vue?vue&type=style&index=0&id=7bfbf153&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bfbf153",
  null
  
)

export default component.exports